import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapboxMapComponent } from './mapbox-map.component';

@NgModule({
  declarations: [
    MapboxMapComponent
  ],
	exports: [
		MapboxMapComponent
	],
  imports: [
    CommonModule
  ]
})
export class MapboxMapModule { }
